import { render, staticRenderFns } from "./SimilarInputs.vue?vue&type=template&id=62fa1383&"
import script from "./SimilarInputs.vue?vue&type=script&lang=js&"
export * from "./SimilarInputs.vue?vue&type=script&lang=js&"
import style0 from "./SimilarInputs.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports